
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import ukran from "../../assets/ukran.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function UkranMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Ukrán magyar fordító</title>
                <meta name='description' content="Ingyenes ukrán magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Ukrán magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/ukran-magyar-fordito" />
            </Helmet>
            <h1>Ukrán magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A Ukrán nyelvről</h2>
                    <img src={ukran} alt="Ukrán zászló"></img>
                </div>

                <p>Az ukrán egy keleti szláv nyelv, amelyet elsősorban Ukrajnában beszélnek. Ukrajna hivatalos nyelve és az Egyesült Nemzetek Szervezetének egyik hivatalos nyelve. Az ukrán nyelv dallamos hangzásáról, gazdag irodalmi hagyományáról és az ukrán nép kulturális identitásának kialakításában betöltött szerepéről ismert.</p>

                <p>Írásrendszere a cirill ábécét használja, hasonlóan az oroszhoz. 33 betűből áll, beleértve az olyan egyedi karaktereket, mint a ї, є és ґ. Az ukrán kiejtése általában fonetikus, ami azt jelenti, hogy a szavakat úgy ejtik ki, ahogy írják őket. Minden betűnek konzisztens hangja van, így viszonylag egyszerű megtanulni az ukrán szavak kiejtését.</p>

                <p>Nyelvtana főnévi ragozásokat, igeragozásokat és nyelvtani eseteket tartalmaz. A főnevek, melléknevek és névmások megváltoztatják alakjukat, hogy jelezzék a nemet, a számot és az esetet. Az ukrán nyelvnek hét esete van: elöljáró, genitivus, datívus, akkuzatívus, instrumentális, lokatívus és vokativus. Az igék ragozása idő, mód, aspektus és személy szerint történik.</p>

                <p>Az ukrán szókincs szláv gyökerekkel rendelkezik, de más nyelvekből származó kölcsönszavakat is tartalmaz, különösen az orosz, a lengyel és az angol nyelvből. Az ukrán irodalom gazdag hagyományokkal rendelkezik, olyan neves szerzőkkel, mint Tarasz Sevcsenko, Ivan Franko és Leszja Ukrainka. Az ukrán kultúra sokszínű, történelme, néphagyományai, zene és konyha befolyásolja.</p>

                <p>Az ukrán nyelvtudás számos lehetőséget kínál. Ukrajna fejlődő gazdasága olyan ágazatokban rejlik, mint az IT, a mezőgazdaság, az energia és a turizmus. Az ukrán nyelv ismerete előnyös lehet ezeken a területeken, vagy az ukrajnai tanulás vagy munka iránt érdeklődők számára.</p>

                <p>A nyelv megértése megkönnyíti a kommunikációt és a kulturális elmélyülést is az ukrán nyelvű közösségekben. Lehetővé teszi az ukrán szokások, hagyományok és társadalmi normák mélyebb megértését. Az ukrán néptáncok, a hagyományos ünnepségek és a konyha az ország gazdag kulturális örökségét tükrözik.</p>

                <p>Sőt, az ukrán nyelv tanulása hozzáférést biztosít Ukrajna kulturális örökségéhez és történelmi jelentőségéhez. Lehetővé teszi Ukrajna ókori történelmének, építészeti nevezetességeinek és természeti szépségének jobb értékelését. Ukrajna változatos régiói, köztük a Kárpátok, a történelmi városok, mint Lviv és Kijev, valamint a Fekete-tenger partvidéke egyedülálló élményeket kínálnak az utazóknak és a kultúra iránt érdeklődőknek.</p>

                <div className="sectionbottom">
                    <Link to="/magyar-ukran-fordito">Magyar ukrán fordító</Link>

                    <img src={ukran} alt="ukrán zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>

            </section>
        </>

    )
}

export default UkranMagyar;